import React from 'react'
import PropTypes from 'prop-types'
import DropdownField from '../../FormComponents/DropdownField/DropdownField'
import SwitchButton from '../../FormComponents/SwitchButton/Switch'
import StateProgressBlock from '../../StatesProgress/StatesProgress'
import { page as pageIndex } from '../../../globals'

class AlertsByCategory extends React.PureComponent {
  returnSubjectRows = () => {
    const { trackData, updateData, type } = this.props
    return subjects.map((item, i) => {
      const className = trackData[type].radio[item.id]
        ? 'alert-row-subj'
        : 'alert-row-subj grey-alert-rows'
      const fieldType = type === 'localCategoryAlerts' ? 'locality' : 'states'
      if (!trackData[type].radio[item.id]) {
        trackData[type].radio[item.id] = false
      }
      return <div key={i} className={className}>
        <div className="alerts-col alert-sub allow-click">
          <SwitchButton
            text="Subscribed"
            location={{ page: pageIndex.dashboard, field: type }}
            id={item.id}
            isEnabled={trackData[type].radio[item.id]}
            updateData={updateData}
          />
        </div>
        <div className="alerts-col alert-sub alert-name">{item.name}</div>
        <div className="alerts-col alert-sub">
          <StateProgressBlock
            page="D"
            field={fieldType}
            values={trackData[type][fieldType]}
            updateData={updateData}
            fieldData={[]}
          />
        </div>
        <div className="alerts-col alert-sub">
          <DropdownField
            id="alertType"
            location={{ page: pageIndex.dashboard, field: type }}
            options={options}
            defaultValue="newUpd"
            value={trackData[type].radio.alertType}
            updateData={updateData}
          />
        </div>
      </div>
    })
  }

  returnTitle = (type) => {
    let title
    let subTitle
    switch (type) {
      case 'legisCategoryAlerts':
        title = 'Legislative'
        subTitle = 'legislation'
        break
      case 'regsCategoryAlerts':
        title = 'Regulatory'
        subTitle = 'regulations'
        break
      case 'localCategoryAlerts':
        title = 'Local Legislative'
        subTitle = 'local legislation'
        break
    }
    return { title, subTitle }
  }

  render () {
    const { type } = this.props
    const { title, subTitle } = this.returnTitle(type)
    const columnTitles = type !== 'localCategoryAlerts' ? titles : titlesLocal
    return <div className="alert-category-body custom-scroll">
      <div className="category-alerts-title">{title} Alerts by Category</div>
      <div className="category-alerts-subtitle">
        Setup or modify e-mail alerts for {subTitle} by subject and state category
      </div>
      <div className="rows-wrapper">
        <div className="alert-title-wrapper">
          {columnTitles.map((item, i) => <div key={i} className="alerts-col title">{item}</div>)}
        </div>
        {this.returnSubjectRows()}
      </div>
    </div>
  }

  static propTypes = {
    trackData: PropTypes.object,
    updateData: PropTypes.func,
    type: PropTypes.string
  }
}

export default AlertsByCategory

const titles = ['Subscribe', 'Subject', 'State', 'Alert Type']
const titlesLocal = ['Subscribe', 'Subject', 'Locality', 'Alert Type']
const subjects = [
  {
    name: 'All subjects',
    states: [],
    alertType: '',
    id: 'sub1'
  },
  {
    name: 'subject 1',
    states: [],
    alertType: '',
    id: 'sub2'
  },
  {
    name: 'subject 2',
    states: [],
    alertType: '',
    id: 'sub3'
  }
]
const options = [
  { value: 'new', label: 'New Alerts Only' },
  { value: 'newUpd', label: 'New Alerts and Updates' },
]



// WEBPACK FOOTER //
// ./src/components/ManagementEmailAlerts/components/AlertsByCategory.js